import { render, staticRenderFns } from "./ScanIn.vue?vue&type=template&id=406f6c71&scoped=true"
import script from "./ScanIn.vue?vue&type=script&lang=js"
export * from "./ScanIn.vue?vue&type=script&lang=js"
import style0 from "./ScanIn.vue?vue&type=style&index=0&id=406f6c71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406f6c71",
  null
  
)

export default component.exports